<template>
  <div class="options-container">
    <split-button v-if="!inactiveZeroBalance">
      <template slot="primary">
        <div @click="triggerRecentParcelsUpdate">
          <a
            :href="parcelViewUrl"
            class="button-label text-decoration-none h-100"
            title="Click For Property Details"
          >
            <div class="primary-link">
              Property Details
            </div>
          </a>
        </div></template
      >
      <split-content>
        <div @click="triggerRecentParcelsUpdate">
          <a
            class="text-decoration-none"
            :href="parcelViewUrl"
            title="Click For Property Details"
          >
            <div class="dropdown-link">
              <ExternalLink />
              Property Details
            </div>
          </a>
        </div>
        <a
          v-if="viewTaxBillUrl && !isFuture"
          class="text-decoration-none"
          :href="viewTaxBillUrl"
          rel="noopener"
          target="_blank"
          title="Click To View Tax Bill"
          ><div class="dropdown-link">
            <DollarBillSVG />
            View Tax Bill
          </div></a
        >
        <div
          v-if="
            status === 'ready' &&
              lteURL &&
              county.lteInstalled &&
              item.TaxType.trim() != 'P' &&
              item.TaxType.trim() != 'Personal' &&
              item.Status.trim().toUpperCase() != 'I'
          "
          @click="eFormsOnClick"
        >
          <div class="dropdown-link">
            <LinkSVG />
            File E-Forms
          </div>
        </div>
        <a
          v-if="item.TaxType === 'R' && parcelPrcUrl && !isFuture"
          class="text-decoration-none"
          :href="parcelPrcUrl"
          rel="noopener"
          target="_blank"
          title="Click To View Property Record Card"
          ><div class="dropdown-link">
            <PDFFileSVG />
            Property Record Card
          </div></a
        >
        <a
          v-if="item.TaxType === 'R' && parcelForm11Url && !isFuture"
          class="text-decoration-none"
          :href="parcelForm11Url"
          rel="noopener"
          target="_blank"
          title="Click To View Form 11"
          ><div class="dropdown-link">
            <PDFFileSVG />
            View Form 11
          </div></a
        >
        <a
          v-if="item.TaxType === 'R' && externalGisParcelUrl && !isFuture"
          class="text-decoration-none"
          :href="externalGisParcelUrl"
          rel="noopener"
          target="_blank"
          title="Click To View Parcel GIS Map"
          ><div class="dropdown-link">
            <MapSVG />
            Parcel GIS Map
          </div></a
        >
        <a
          v-if="
            item.TaxType === 'R' &&
              externalGisCountyUrl &&
              !externalGisParcelUrl &&
              !isFuture
          "
          class="text-decoration-none"
          :href="externalGisCountyUrl"
          rel="noopener"
          target="_blank"
          title="Click To View County GIS Map"
          ><div class="dropdown-link">
            <MapSVG />
            County GIS Map
          </div></a
        >
      </split-content>
    </split-button>
    <div v-else @click="triggerRecentParcelsUpdate" class="dropdown-button">
      <a
        :href="parcelViewUrl"
        class="rounded flex-button mx-3 text-decoration-none button-label"
        title="Click For Property Details"
      >
        <div class="primary-link">
          Property Details
        </div>
      </a>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import SplitButton from "../common/SplitButton.vue";
import SplitContent from "../common/SplitContent.vue";
import DollarBillSVG from "../svg/DollarBillSVG.vue";
import ExternalLink from "../svg/ExternalLink.vue";
import LinkSVG from "../svg/LinkSVG.vue";
import PDFFileSVG from "../svg/PDFFileSVG.vue";
import MapSVG from "../svg/MapSVG.vue";
export default {
  components: {
    MapSVG,
    LinkSVG,
    PDFFileSVG,
    DollarBillSVG,
    ExternalLink,
    SplitButton,
    SplitContent,
  },
  data() {
    return {
      parcelState: null,
      inactive: false,
    };
  },
  methods: {
    triggerRecentParcelsUpdate: function() {
      this.updateRecentParcels(this.item.DuplicateNumber, this.item);
    },
    eFormsOnClick: function() {
      if (!this.parcelState || this.inactive) {
        this.axios
          .get(process.env.VUE_APP_DATASERVICE + "GetParcel", {
            params: {
              CorpCode: this.county.corpCode.toUpperCase(),
              dup: this.item.DuplicateNumber,
              PayYear: parseInt(this.currentPayYear),
            },
          })
          .then((response) => {
            this.error = null;
            this.parcelState = response.data;
            this.inactive =
              this.parcelState.propertyInfo.Status.trim().toUpperCase() ===
                "I" ||
              this.parcelState.propertyInfo.Status.trim().toUpperCase() ===
                "INACTIVE";
            if (this.inactive) {
              this.showEFormsAlert();
            } else {
              window.open(this.lteURL, "_blank");
            }
          })
          .catch((error) => {
            this.inactive = true;
            this.showEFormsAlert();
          });
      } else {
        if (!this.inactive) {
          this.inactive =
            this.parcelState.propertyInfo.Status.trim().toUpperCase() === "I";
        }
        if (this.inactive) {
          this.showEFormsAlert();
        } else {
          window.open(this.lteURL, "_blank");
        }
      }
    },
  },
  computed: {
    parcelViewUrl: function() {
      if (
        this.status === "recentParcels" &&
        this.county.slug &&
        this.item.DuplicateNumber
      ) {
        if (this.currentPayYear >= this.item.PayYear) {
          return `${process.env.BASE_URL}${this.county.slug}/${this.item.DuplicateNumber}-${this.currentPayYear}`;
        } else {
          return `${process.env.BASE_URL}${this.county.slug}/${this.item.DuplicateNumber}-${this.item.PayYear}`;
        }
      } else if (
        !this.county.slug ||
        !this.item.DuplicateNumber ||
        !this.item.PayYear
      ) {
        return;
      } else {
        return `${process.env.BASE_URL}${this.county.slug}/${this.item.DuplicateNumber}-${this.item.PayYear}`;
      }
    },
    viewTaxBillUrl: function() {
      if (!this.county.corpCode || !this.item.DuplicateNumber) {
        return;
      }
      return (
        process.env.VUE_APP_TAXBILLSERVICE +
        "?county=" +
        this.county.corpCode +
        "&dup=" +
        this.item.DuplicateNumber
      );
    },
    parcelPrcUrl: function() {
      if (!this.county.prcUrl) {
        return;
      }
      let url = this.county.prcUrl;
      url = url.replace("{{StateKey}}", this.stateKey);
      url = url.replace("{{UnformattedStateKey}}", this.unformattedStateKey);
      url = url.replace("{{PayYear}}", this.item.PayYear);
      return url;
    },
    parcelForm11Url: function() {
      if (!this.county.form11Url) {
        return;
      }
      let url = this.county.form11Url;
      url = url.replace("{{StateKey}}", this.stateKey);
      url = url.replace("{{UnformattedStateKey}}", this.unformattedStateKey);
      return url;
    },
    externalGisParcelUrl: function() {
      if (!this.county.externalGisParcelUrl) {
        return;
      }
      let url = this.county.externalGisParcelUrl;
      url = url.replace("{{StateKey}}", this.stateKey);
      url = url.replace("{{UnformattedStateKey}}", this.unformattedStateKey);
      return url;
    },
    externalGisCountyUrl: function() {
      return this.county.externalGisUrl;
    },
    lteURL() {
      let url = process.env.VUE_APP_LTE;
      if (!url) {
        return;
      }
      url = url.replace("{{CorpCode}}", this.county.corpCode);
      url = url.replace("{{Dup}}", this.item.DuplicateNumber);
      return url;
    },
  },

  props: {
    updateRecentParcels: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    stateKey: {
      type: String,
      required: true,
    },
    unformattedStateKey: {
      type: String,
      required: true,
    },
    county: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    status: {
      // ready|cancelled|searching|error|recentParcels
      required: true,
      type: String,
    },
    currentPayYear: {
      type: String,
      required: false,
    },
    showEFormsAlert: {
      type: Function,
      required: false,
    },
    inactiveZeroBalance: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
